/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useContext, Fragment} from 'react';
import {TableBasic, TableDefault, TagWrapperRounder, MediaBadge, MediaBadgeText, ColumnSubtitle, ColumnTitle} from './styles';
import Media from '../Media/Media';
// import ButtonXlsx from '../ButtonXlsx/ButtonXlsx';
import {Badge, RequestPendingRow, InputCheckbox, Tag} from '..';
import {ARMcontext} from '../../utils/context/context';

import Utils, {deepGet} from '../../utils/api/Utils';
import {GoChevronDown, GoChevronUp} from 'react-icons/go';
export default ({
  dataTableContent,
  filter,
  minWidth,
  dataMainHead,
  dataTableHead,
  handleClick,
  typeOfTable,
  HandleOne,
  handleRequest,
  HandleAll,
  check,
  selectedTeam,
  individualFilter,
}: {
  dataTableContent: Array<any>;
  filter: any;
  dataMainHead: Array<any>;
  dataTableHead: Array<{title: string; colSpan: any; examType: Array<any>}>;
  handleClick?: any;
  typeOfTable?: any;
  HandleOne?: any;
  HandleAll?: any;
  check?: any;
  minWidth?: string;
  selectedTeam?: string;
  individualFilter?: any;

  handleRequest?: any;
}) => {
  const {user} = useContext(ARMcontext);
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [reverse, useReverse] = useState<boolean>(false);
  const [isActive, setActiveClass] = useState('');
  const UTILS = new Utils();
  const isWord = UTILS.GetValidationInputPattern();
  const HandleSort = UTILS.HandleSort;
  const sortOptions = [reverse, useReverse, setActiveClass, useTable, table, isWord];
  useEffect(() => {useTable(dataTableContent)
    HandleSort('STATUS', ['status'], [!reverse, useReverse, setActiveClass, useTable, dataTableContent, isWord]);
  }, [dataTableContent]);
  function createTableRow(element, atributes) {
    const columns = atributes.map((prop, index) => {
      if (prop.title === 'PAYMENT') {
        const value = deepGet(element, [...prop.examType]);
        const enddate = deepGet(element, ['sponsorshipEndDate']);
        return (
          <td key={element._id + '_' + index}>
            <ColumnTitle>{value === 0 ? value : value || ''}</ColumnTitle>
            {enddate && <ColumnSubtitle> {'Expires on ' + new Date(enddate).toLocaleDateString('en-US')}</ColumnSubtitle>}
          </td>
        );
      }
      if (prop.title === 'PLAYERS' || prop.title === 'COACH') {
        return (
          <td key={'name' + element._id}>
            <MediaBadge>
              <InputCheckbox onClick={() => (HandleOne ? HandleOne(element) : '')} checked={element?.checked || false} />
              <Media imgUrl={element.picture} name={`${element.firstName} ${element.lastName}`} />
            </MediaBadge>
          </td>
        );
      }
      if (prop.title === 'DATE' || prop.examType[0] === 'createdAt') {
        return <td key={'date' + element._id}>{new Date(deepGet(element, [...prop.examType])).toLocaleDateString('en-US')}</td>;
      }
      if (prop.title === 'EXAM') {
        return (
          <td key={'exam' + element._id}>
            {deepGet(element, ['summary', 'kind']) === 'medical-quick-screen' && 'MQS'}
            {deepGet(element, ['summary', 'kind']) === 'quick-screen' && 'QS'}
            {deepGet(element, ['summary', 'kind']) === undefined && ''}
          </td>
        );
      }
      if (prop.title === 'TEAM/GROUP') {
        return (
          <td key={'teamgroup' + element._id}>
            <MediaBadge>
              {element.picture && element.name !== 'All Players' ? (
                <Media imgUrl={element.picture} size="33px" />
              ) : element.badge === 'ALL' ? (
                <Badge color="#007AFF" size={'32px'} font={'16px'} />
              ) : (
                <Badge text={element?.badge || element.initials} color={element?.color} size={'32px'} font={'16px'} />
              )}
              <MediaBadgeText>{element.name}</MediaBadgeText>
            </MediaBadge>
          </td>
        );
      }

      if (prop.title === 'STATUS') {
        return (
          <td key={element._id + '-' + index}>
            <Tag name={element.status} theme={element.status} />
          </td>
        );
      }
      if (prop.title === 'TEAM ACCESS') {
        return (
          <td key={element._id + '-' + index}>
            {element.teams.length > 0 ? (
              <TagWrapperRounder>
                {element.teams?.map((team: any, index: string) => (
                  <Fragment key={index}>
                    <Tag name={team.name} theme="border" size="large" />
                  </Fragment>
                ))}
              </TagWrapperRounder>
            ) : element.allTeams ? (
              'All'
            ) : (
              ''
            )}
          </td>
        );
      } else {
        const value = deepGet(element, [...prop.examType]);
        return <td key={element._id + '_' + index}>{value === 0 ? value : value || ''}</td>;
      }
    });
    return (
      <tr key={element._id ? element._id : element.name + '__'} onClick={() => (handleClick ? handleClick(element) : '')}>
        {element.status === 'Pending' &&
        (user?.data?.role === 'org-admin' || user?.data?.isAdmin) &&
        element.invitationType === 'Request' ? (
          <>
            <RequestPendingRow
              age={element.age}
              email={element.email}
              imgUrl={element.picture}
              checked={element.checked}
              invitationID={element._id}
              onCheckbox={() => HandleOne(element)}
              position={element.position}
              callback={handleRequest}
              name={`${element.firstName} ${element.lastName}`}
            />
          </>
        ) : (
          columns
        )}
      </tr>
    );
  }

  return (
    <>
      {typeOfTable === 1 ? (
        <>
          <TableBasic minWidth={minWidth}>
            <thead>
              {dataMainHead.length > 0 ? (
                <tr>
                  {dataMainHead.map((item, index) => (
                    <th key={index} colSpan={item.colSpan}>
                      {item.title}
                    </th>
                  ))}
                </tr>
              ) : (
                <></>
              )}

              <tr>
                {dataTableHead.map((item, index) =>
                  item.title === 'PLAYERS' || item.title === 'COACH' ? (
                    <th key={index} colSpan={1}>
                      <InputCheckbox onClick={() => (HandleAll ? HandleAll(!check) : '')} checked={check} />
                      <span onClick={() => HandleSort(item.title, item.examType, sortOptions)}>{item.title}</span>
                      {isActive === item.title && reverse && <GoChevronDown />}
                      {isActive === item.title && !reverse && <GoChevronUp />}
                    </th>
                  ) : (
                    <th onClick={() => HandleSort(item.title, item.examType, sortOptions)} key={index} colSpan={1}>
                      <span>{item.title}</span>
                      {isActive === item.title && reverse && <GoChevronDown />}
                      {isActive === item.title && !reverse && <GoChevronUp />}
                    </th>
                  ),
                )}
              </tr>
            </thead>
            <tbody className="table-player-exam">
              {table.length ? (
                table
                  .filter(el => {
                    if (!Boolean(selectedTeam)) {
                      return true;
                    } else if (selectedTeam === el?.team?._id) {
                      return true;
                    } else if (Boolean(el.teams?.filter(il => il._id === selectedTeam)[0])) {
                      return true;
                    } else {
                      return false;
                    }
                  })
                  .filter(el => {
                    if (individualFilter.title === 'All Players' || individualFilter.title === 'All Coaches') {
                      return true;
                    } else if (individualFilter.title === el.primaryPosition) {
                      return true;
                    } else if (individualFilter.title === el.role) {
                      return true;
                    } else {
                      return false;
                    }
                  })
                  .filter(el => {
                    const playerName: string = el?.firstName || '';
                    const playerLast: string = el?.lastName || '';
                    const name = `${playerName} ${playerLast}`;
                    return name.toLocaleLowerCase().includes(filter.value.toLowerCase());
                  })
                  .map((item, index) => createTableRow(item, dataTableHead))
              ) : (
                <tr>
                  <td colSpan={18}>No Data</td>
                </tr>
              )}
            </tbody>
          </TableBasic>
        </>
      ) : (
        <>
          <TableDefault minWidth={minWidth}>
            <thead>
              <tr>
                {dataMainHead?.map((item, index) => (
                  <th key={index} colSpan={item.colSpan}>
                    {item.title}
                  </th>
                ))}
              </tr>
              <tr>
                {dataTableHead.map((item, index) => (
                  <th onClick={() => HandleSort(item.title, item.examType, sortOptions)} key={index} colSpan={1}>
                    <span>{item.title}</span>
                    {isActive === item.title && reverse && <GoChevronDown />}
                    {isActive === item.title && !reverse && <GoChevronUp />}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="table-player-exam">
              {table.length ? (
                table.map((item, index) => createTableRow(item, dataTableHead))
              ) : (
                <tr>
                  <td colSpan={18}>No Data</td>
                </tr>
              )}
            </tbody>
          </TableDefault>
        </>
      )}
    </>
  );
};
